<template>
  <v-container class="pa-0">
    <template
      v-if="viewDataIsLoaded"
    >
      <!--stuff only to show when viewDataIsLoaded-->
      <v-alert
        prominent
        type="error"
        v-model="postWasInvalid"
        class="mb-4"
      >
        <v-row align="center">
          <v-col class="grow">
            <div class="text-h4 pb-2">Hoppsan :-/</div>
            <p v-html="errorOutput"></p>
          </v-col>
          <v-col class="shrink">
            <v-btn @click="onErrorOk()">OK</v-btn>
          </v-col>
        </v-row>
      </v-alert>
      <v-row
        v-if="!postWasInvalid"
        class="mb-6"
      >
        <v-col cols="6">
          <v-btn
            color="accent"
            @click="doSubmit()"
            large
          >
            {{ this.submitText }}
          </v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn
            v-if="removable"
            color="error"
            @click.stop="onRemoveDialog(true)"
            text
          >
            {{ txtRemoveDialogButton }}
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="removable">
        <!--removeDialog-->
        <v-dialog
          v-if="removable"
          v-model="removeDialog"
          max-width="320"
          dark
        >
          <v-card>
            <v-card-title class="headline">{{ txtRemoveDialogTitle_toUse }}</v-card-title>
            <v-card-text>
              {{ txtRemoveDialogText_toUse }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="onRemoveDialog(false)"
              >
                Nej
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                text
                @click="remove()"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
    <!--loader-->
    <v-overlay
      :value="loader"
      opacity="0.8"
      z-index="1001"
    >
      <v-progress-circular
        :size="60"
        color="secondary"
        :indeterminate="!progress"
        :value="progressPercent"
        :rotate="-90"
      >
      </v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
export default {
  props: {
    viewDataIsLoaded: {
      type: Boolean,
      default: true
    },
    errorOutput: {
      type: String,
      default: ''
    },
    postWasInvalid: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    removeDialog: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    txtAnObject: {
      type: String,
      default: 'Objekt'
    },
    txtTheObject: {
      type: String,
      default: 'Objektet'
    },
    submitText: {
      type: String,
      default: "Spara"
    },
    progress: {
      type: Boolean,
      default: false
    },
    progressPercent: {
      type: Number,
      default: 0
    },
    txtRemoveDialogButton: {
      type: String,
      default: 'Ta bort'
    },
    txtRemoveDialogTitle: {
      type: String,
      required: false
    },
    txtRemoveDialogText: {
      type: String,
      required: false
    }
  },
  data: () => ({
    //we cannont mutate props, so we do this
    txtRemoveDialogTitle_toUse: '',
    txtRemoveDialogText_toUse: ''
  }),
  methods: {
    doSubmit() {
      this.$emit('onSubmit')
    },
    remove() {
      this.$emit('onRemove')
    },
    onErrorOk() {
      this.$emit('onErrorOk')
    },
    onRemoveDialog(show) {
      if (show) {
        this.$emit('onRemoveDialogOpen')
      } else {
        this.$emit('onRemoveDialogClose')
      }
    }
  },
  created() {
    //we cannont mutate props, so we do this
    this.txtRemoveDialogTitle_toUse = (this.txtRemoveDialogTitle) ? this.txtRemoveDialogTitle : 'Ta bort ' + this.txtAnObject
    this.txtRemoveDialogText_toUse = (this.txtRemoveDialogText) ? this.txtRemoveDialogText : 'Vill du verkligen ta bort ' + this.txtTheObject
  }
}
</script>

<style>

</style>